<template>
  <div class="layout">
    <div class="aside">
      <slot name="aside"></slot>
    </div>
    <div class="main">
      <div class="nav">
        <slot name="nav"></slot>
      </div>
      <div class="content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  
}
</script>
<style lang="less" scoped>
@deepBlack: #18191A;
@shadowBlack: #2C2C2E;
.layout {
  width: 100%;
  height: 100%;
  padding: 10px;
  background: @deepBlack;
  display: flex;
  .aside {
    flex: none;
    width: 240px;
    height: 100%;
    margin-right: 10px;
    background: @shadowBlack;
    border-radius: 10px;
  }
  .main {
    flex: auto;
    display: flex;
    flex-direction: column;
    .nav {
      flex: none;
      width: 100%;
      height: 78px;
      margin-bottom: 10px;
      background: @shadowBlack;
      border-radius: 10px;
    }
    .content {
      flex: auto;
      border-radius: 10px;
      background: @deepBlack;
    }
  }
}
</style>